import React, { useState, useEffect } from 'react';
const axios = require('axios').default;
const Item = ({ vars }) => {
    const [attributes, setAttributes] = useState({
        item: vars.item,
        type: vars.category,
        mapUrl: vars.mapUrl
    });
    // Load all functions for the current form
    useEffect(() => {
        return () => {
        };
    }, []);
    const onClick = (e) => {
        window.location = item.link;
    };
    let item = attributes.item;
    let badges;
    let description;
    if (item.category == "adv") {
        badges = (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "badges" },
                React.createElement("span", { className: "price" }, item.price),
                item.is_for_disabled_person ? React.createElement("span", { className: "icon" },
                    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "23.483", height: "24.096", viewBox: "0 0 23.483 24.096" },
                        React.createElement("path", { className: "colored", d: "M13.489,230.5a.954.954,0,0,0-1.256.491,5.4,5.4,0,1,1-7.123-7.109.954.954,0,1,0-.765-1.747,7.305,7.305,0,1,0,9.635,9.649.961.961,0,0,0-.491-1.284Z", transform: "translate(0 -212.026)", fill: "#ed1c24" }),
                        React.createElement("path", { className: "colored", d: "M114.876,5.726a2.863,2.863,0,1,0-2.037-.851,2.863,2.863,0,0,0,2.037.851Z", transform: "translate(-106.959 0)", fill: "#ed1c24" }),
                        React.createElement("path", { className: "colored", d: "M170.743,166.2a.955.955,0,0,0-1.284-.421l-1.874.933-3.326-3.881a.962.962,0,0,0-.7-.33H156.23v-6.358h5.712a.954.954,0,1,0,0-1.9h-6.667a.947.947,0,0,0-.954.947v8.267a.947.947,0,0,0,.954.947h7.818l3.509,4.119h0a.933.933,0,0,0,.7.33,1.034,1.034,0,0,0,.428-.1l2.583-1.27a.961.961,0,0,0,.428-1.284Z", transform: "translate(-147.359 -147.278)", fill: "#ed1c24" }),
                        React.createElement("path", { d: "M156.227,43.26a.955.955,0,1,1-.955-.955.955.955,0,0,1,.955.955", transform: "translate(-147.356 -40.396)", fill: "#fff", stroke: "rgba(0,0,0,0)", strokeWidth: "1" })),
                    React.createElement("span", null, vars.l("yes"))) : "")));
        description = (React.createElement("div", { className: "description" },
            item.dates.start.H,
            " ",
            `>`,
            " ",
            item.dates.end.H));
    }
    else {
        description = React.createElement("div", { className: "description", dangerouslySetInnerHTML: { __html: item.overview } });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `item-element scheme-${item.category}` },
            React.createElement("div", { className: "picture", onClick: onClick },
                React.createElement("img", { src: item.poster, alt: "{item.name}" })),
            React.createElement("div", { className: "content", onClick: onClick },
                React.createElement("div", null,
                    React.createElement("h2", null,
                        React.createElement("a", { href: item.link }, item.name)),
                    React.createElement("div", { onClick: onClick }, description),
                    React.createElement("div", { className: "bottom" },
                        badges,
                        React.createElement("a", { className: "gotoMap", href: `${attributes.mapUrl}?lat=${item.lat}&lng=${item.lng}` },
                            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "48", height: "48", viewBox: "0 0 48 48" },
                                React.createElement("g", { transform: "translate(-25 -491)" },
                                    React.createElement("rect", { width: "48", height: "48", rx: "10", transform: "translate(25 491)", fill: "#ed1c24" }),
                                    React.createElement("g", { transform: "translate(36.021 499.511)" },
                                        React.createElement("path", { d: "M30.459,14.479c0,10.1-12.979,18.748-12.979,18.748S4.5,24.574,4.5,14.479a12.979,12.979,0,0,1,25.959,0Z", transform: "translate(-4.5 -1.5)", fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
                                        React.createElement("path", { d: "M22.3,14.9a4.4,4.4,0,1,1-4.4-4.4A4.4,4.4,0,0,1,22.3,14.9Z", transform: "translate(-4.919 -1.901)", fill: "none", stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })))))))))));
};
export default Item;
